import useIsMobile from "../hooks/useIsMobile";

const textareaStyle = (error) => ({
  width: "100%",
  padding: "12px 16px",
  border: `2px solid ${error ? "#e53e3e" : "#e8e0d4"}`,
  borderRadius: "10px",
  fontSize: "15px",
  fontFamily: "'DM Sans', sans-serif",
  backgroundColor: error ? "#fff5f5" : "#fdfbf7",
  color: "#2d2418",
  transition: "all 0.2s ease",
  outline: "none",
  boxSizing: "border-box",
  resize: "vertical",
  minHeight: "100px",
  lineHeight: 1.6,
});

export default function TextareaField({ label, value, onChange, placeholder, required = false, half = false, error = "", rows = 4 }) {
  const isMobile = useIsMobile();

  return (
    <div style={{ flex: half ? "1 1 48%" : "1 1 100%", minWidth: half ? (isMobile ? 0 : "220px") : "auto" }}>
      <label
        style={{
          display: "block",
          fontSize: "13px",
          fontWeight: 600,
          color: "#4a3f35",
          marginBottom: "6px",
          fontFamily: "'DM Sans', sans-serif",
          letterSpacing: "0.02em",
        }}
      >
        {label}
        {required && <span style={{ color: "#c45d3e" }}> *</span>}
      </label>
      <textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        style={textareaStyle(error)}
        onFocus={(e) => {
          e.target.style.borderColor = error ? "#e53e3e" : "#c45d3e";
          e.target.style.backgroundColor = "#fff";
          e.target.style.boxShadow = `0 0 0 3px ${error ? "rgba(229, 62, 62, 0.1)" : "rgba(196, 93, 62, 0.1)"}`;
        }}
        onBlur={(e) => {
          e.target.style.borderColor = error ? "#e53e3e" : "#e8e0d4";
          e.target.style.backgroundColor = error ? "#fff5f5" : "#fdfbf7";
          e.target.style.boxShadow = "none";
        }}
      />
      {error && (
        <p style={{
          fontSize: "12px",
          color: "#e53e3e",
          margin: "4px 0 0 0",
          fontFamily: "'DM Sans', sans-serif",
        }}>
          {error}
        </p>
      )}
    </div>
  );
}
